import { GameVars } from "./../../GameVars";

export class Background extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.scaleX = GameVars.scaleX;

        for (let i = 0; i < 18; i++) {

            const bg = this.scene.add.image(0, 0, "bg");
            bg.setOrigin(0);
            bg.x = bg.width * i;
            this.add(bg);
        }
    }
}
